import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ManagerHeader from "../manager-dashboard/ManagerHeader.js";
import api from "../../api/axios.js";

const ManagerDashboard = () => {
    const [stats, setStats] = useState(null);
    const [managerId, setManagerId] = useState("");

    // for demo
    // const managerId = "101";

    useEffect(() => {
        api
        .get("/auth/me")
        .then((res) => {
            setManagerId(res.data.managerId);
        })
        .catch((err) => {
            console.log(err);
        });
    }, []);

    useEffect(() => {
        if(!managerId) return;
        api
        .get("/api/feedback/manager/" + managerId + "/dashboard-stats")
        .then((res) => {
            setStats(res.data);
           })
           .catch((err) => {
            console.log(err);
           });
    }, [managerId]);

    if(!stats) return <p>Loading...</p>

    const passRate = stats.passRate || 0;
    const failRate = stats.failRate || 0;
    const completionRate = stats.completionRate || 0;
    const overviewRows = stats.overviewRows || [];

    return (
        <>
            <div className="dashboard-wrapper">
                <ManagerHeader /> 

                <div className="manager-dashboard-box">

                    <h2>Dashboard</h2>
                    
                                <div className="manager-dashboard-dashboard-left">
                                    <div className="total-employee-number">
                                        <p className="manager-dashboard-total-employee">Total employees</p>
                                        <p className="manager-dashboard-total-number">{stats.totalEmployees}</p>
                                        <img src="/images/person.png" alt="person-icon" />
                                    </div>

                                    <div className="manager-dashboard-quiz-completion-rate">
                                        <p className="manager-dashboard-total-employee">Quiz completed</p>
                                        <p className="manager-dashboard-total-number">{completionRate}%</p>
                                    </div>
                                </div>

                                <div className="manager-dashboard-dashboard-passrate-title">
                                    <div className="passrate-title">
                                        <p>Pass rate</p>
                                        <img src="/images/information-circle.png" alt="profile-icon" />
                                    </div>
                                

                                <div className="manager-dashboard-dashboard-passrate-graph">
                                        <div className="donut-wrapper">
                                            <div className="donut-chart"
                                                 style={{background: `conic-gradient( #98AC64 ${passRate}%, #C50404 ${passRate}%)`}} >
                                                    <div className="donut-inner">
                                                        <p>{passRate}%</p>
                                                    </div>
                                            </div>
                                            <div className="donut-legend">
                                                <div>
                                                    <span className="legend-box pass"></span>PASS
                                                </div>
                                                <div>
                                                    <span className="legend-box fail"></span>FAIL
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            
                    

                    <h2>Overview</h2>


                        <div className="manager-dashboard-overview">
                            <table className="overview-table">
                                <thead>
                                    <tr>
                                        <th>Employee</th>
                                        <th>Quiz completed</th>
                                        <th>Average score</th>
                                        <th>Complete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {overviewRows.map((row, index) => {
                                        console.log("row:", row);
                                        return(
                                            <tr key={index}>
                                                <td>{row.employeeName}</td>
                                                <td>{row.quizCompleted}</td>
                                                <td>{row.averageScore}</td>
                                                <td>
                                                    <span className={row.completedStatus === "Finished" ? "overview-status finished" : "overview-status progress"}>{row.completedStatus}</span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                </div>
            </div>

        </>
    );

}

export default ManagerDashboard;